
import styles from '../style.module.css';
import langData from "../../../lang/data";
import {useSelector} from "react-redux";
import NewsItem from "./NewsItem";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useRef } from "react";

function News({ news = [] }) {

    const { currentLanguage } = useSelector(({ main }) => main);
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    if (!news.length) return null;

    return (
        <div className={styles.news_section}>
            <div className={styles.news_header}>
                <h3>{ langData.titles.BlogTitleSecond[currentLanguage] }</h3>
                <div className={styles.news_nav}>
                    <button
                        type="button"
                        ref={prevRef}
                        className={styles.news_nav_btn}
                        aria-label="Previous news"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
                            <path d="M5.24996 0.75L0.75 5.25002L5.25 9.75002" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                    <button
                        type="button"
                        ref={nextRef}
                        className={styles.news_nav_btn}
                        aria-label="Next news"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
                            <path d="M0.750037 0.75L5.25 5.25002L0.75 9.75002" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>
            </div>
            <Swiper
                className={styles.news_swiper}
                modules={[Navigation]}
                spaceBetween={16}
                slidesPerView={4}
                onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                }}
                navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                }}
                breakpoints={{
                    0: { slidesPerView: 1.15, spaceBetween: 12 },
                    568: { slidesPerView: 2, spaceBetween: 14 },
                    993: { slidesPerView: 3, spaceBetween: 16 },
                    1200: { slidesPerView: 4, spaceBetween: 16 },
                }}
            >
                {news.map((item) => (
                    <SwiperSlide key={item.id} className={styles.news_slide}>
                        <NewsItem news={item} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}

export default News;
